<script>
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import EntityLink from '../UI/Button/EntityLink.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import FormCreator from '../UI/Form/FormCreator.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import Badge from '../UI/Badge.vue'
import ActorFormModal from './ActorFormModal.vue'
import { isTheme } from '../../Utils/isTheme'

export default {
  components: { ActorFormModal, Badge, FieldCreator, FormCreator, EntityLink, BlockContent, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    disabled: { type: Boolean, default: false },
    id: { type: Number, required: true },
    endpoint: { type: String, required: true },
    context: { type: String, required: true, validator: (value) => ['simulation', 'contract'].includes(value) },
  },

  data() {
    return {
      obj: {},
      loading: false,
      sending: false,
      sendingShare: false,
      loadFormNewActor: false,
      loadField: false,
      loadFieldActor: false,
      loadFieldNewActor: false,
      actorType: null,
      showActor: false,
      params: {},
      paramsActor: {},
      actors: {
        SURRENDER: [],
        COMMISSION: [],
      },
      equipment: {},
      formData: null,
    }
  },
  methods: {
    updateData(newData) {
      this.formData = newData
    },
    setBuild(bool) {
      this.loadField = bool
    },
    setElement(def, obj) {
      this.obj = obj
      this.$root.addValue(this.equipment, obj.equipment)
      this.getActors(obj.finance.actors)
      this.showActor = true
    },
    setBuildActor(bool) {
      this.loadFieldActor = bool
    },
    setBuildNewActor(bool) {
      this.loadFieldNewActor = bool
    },
    setDatas(json) {
      this.$emit('contributor-sent', json)
    },
    setNewActor(actor) {
      if (actor) {
        if (!this.actors[actor.type]) {
          this.actors[actor.type] = []
        }
        this.$root.addValue(this.actors[actor.type], actor)
        this.closeModal()
      } else {
        document.getElementById('invalid-feedback-entity').innerHTML = this.$t('actor.fields.entity.errorExist')
      }
    },
    isSending(bool) {
      this.sending = bool
    },
    isSendingShare(bool) {
      this.sendingShare = bool
    },
    showFormActor(id) {
      this.$refs['actor' + id][0].showForm()
    },
    isLoading(bool) {
      this.loading = bool
    },
    updateActor(json) {
      this.$emit('reload-data')
      let index = this.actors[json.type].findIndex((r) => r.id === json.id)
      this.$root.addValue(this.actors[json.type][index], json)
    },
    showNewActor(type = null) {
      this.paramsActor = { financeId: this.obj.finance.id }
      if (type) {
        this.actorType = type
      }
      this.loadFormNewActor = true
    },
    openModal() {
      this.$refs['modal-actor'].open()
    },
    closeModal() {
      this.sending = false
      this.loadFormNewActor = false
      this.loadFieldNewActor = false
      this.actorType = null
      this.$refs['modal-actor'].close(false)
    },
    postNewActor() {
      if (this.actorType) {
        this.$refs.newactor.datas['type'] = this.actorType
      }
      this.$refs.newactor.datas['financeId'] = this.obj.finance.id
      this.$refs.newactor.methods()
    },
    getActors(actors) {
      actors.map((actor) => {
        if (!this.actors[actor.type]) {
          this.actors[actor.type] = []
        }
        this.actors[actor.type].push(actor)
      })

      if (this.actors['COMMISSION'] && this.actors['COMMISSION'].length === 0) {
        delete this.actors.COMMISSION
      }
      if (this.actors['SURRENDER'] && this.actors['SURRENDER'].length === 0) {
        delete this.actors.SURRENDER
      }

      return this.actors
    },
    getUsersByType(type, actor) {
      return [
        { label: 'actor.fields.director.label', property: 'director' },
        {
          label: this.$te(`actor.fields.signer.label.${type}`)
            ? `actor.fields.signer.label.${type}`
            : `actor.fields.signer.label.default`,
          property: 'signer',
        },
        {
          label: this.$te(`actor.fields.executiveSigner.label.${type}`)
            ? `actor.fields.executiveSigner.label.${type}`
            : `actor.fields.executiveSigner.label.default`,
          property: 'executiveSigner',
          onlyFor: 'CLIENT',
        },
        ...(!isTheme('lbp')
          ? []
          : [
              {
                label: this.$te(`actor.fields.approvers.label.${type}`)
                  ? `actor.fields.approvers.label.${type}`
                  : `actor.fields.approvers.label.default`,
                property: 'approvers',
                onlyFor: 'CLIENT',
              },
              {
                label: this.$t('contract.fields.signers.surrenderApproverSigners.label'),
                property: 'approvers',
                onlyFor: 'SURRENDER',
              },
            ]),
        {
          label: this.$te(`actor.fields.accountContact.label.${type}`)
            ? `actor.fields.accountContact.label.${type}`
            : `actor.fields.accountContact.label.default`,
          property: 'accountContact',
        },
        {
          label: this.$te(`actor.fields.billingContacts.label.${type}`)
            ? `actor.fields.billingContacts.label.${type}`
            : `actor.fields.billingContacts.label.default`,
          collectionProperty: 'billingContacts',
          property: 'user',
        },
      ]
    },
    entitySirenLabel(actor) {
      if (actor?.entity?.countryCode === 'ES') {
        return this.$t('entity.nif.title')
      }

      return this.$t('entity.siren')
    },
    addShareRent(id) {
      this.$refs['actor-' + id][0].datas['financeId'] = this.obj.finance.id
      this.$refs['actor-' + id][0].methods()
    },
    deleteActor(id) {
      this.$refs['actor-' + id][0].datas['financeId'] = this.obj.finance.id
      this.$refs['actor-' + id][0].methods('delete')
    },
    removeActor(obj) {
      location.reload()
    },
    localRenderEntity(entity) {
      return this.$root.renderEntity(entity)
    },
  },

  beforeMount() {
    this.params = this.endpoint === 'quotations' ? { simulationId: this.id } : null
  },
}
</script>
<template>
  <div id="page-actors">
    <FormCreator
      @update-data="updateData"
      ref="contributor"
      :endpoint="endpoint"
      src-error="contributor"
      :id="id"
      :params="params"
      method="patch"
      class-to-add="d-none"
      @form-build="setBuild"
      @element-build="setElement"
      @form-return="setDatas"
    />

    <ModalDialog
      id="modal-actor"
      ref="modal-actor"
      id-modal-page="page-actors"
      class-modal-dialog="modal-lg"
      multiple
      @icon-close="closeModal"
      e2e-modal="actors"
    >
      <FormCreator
        v-if="loadFormNewActor"
        ref="newactor"
        endpoint="actors"
        method="post"
        :params="paramsActor"
        :in-modal="true"
        class-to-add="d-none"
        @modal-build="openModal"
        @form-build="setBuildNewActor"
        @update-data="updateData"
        @form-return="setNewActor"
        @is-sending="isSending"
      />
      <template #body>
        <FieldCreator
          :form-data="formData"
          v-if="loadFieldNewActor && !actorType"
          name="type"
          form-ref="newactor"
          domain="actor"
          label-top
          type-value="string"
        />
        <FieldCreator
          :form-data="formData"
          v-if="loadFieldNewActor"
          name="entity"
          form-ref="newactor"
          domain="actor"
          value-property="id"
          label-top
          add-entity
        />
      </template>
      <template #footer>
        <button type="button" class="btn btn-primary" @click="postNewActor">
          <div v-if="sending" class="text-center">
            <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-else>
            {{ $t('actor.button.validate') }}
          </div>
        </button>
        <button type="button" class="btn btn-info" @click="closeModal">{{ $t('main.close') }}</button>
      </template>
    </ModalDialog>

    <div v-if="showActor">
      <BlockContent
        v-for="(act, ind) in actors"
        :key="ind"
        inner-bloc-class="border-contract-blue"
        :e2e-block="'actor' + ind"
        :e2e-row="'actor-' + ind"
      >
        <h5 class="text-info">{{ $t('actor.information.' + ind) }}</h5>
        <div v-for="(actor, index) in act" :key="actor.id" class="my-3" style="border-bottom: 1px dashed grey">
          <FormCreator
            @update-data="updateData"
            :ref="'actor-' + actor.id"
            endpoint="actors"
            method="patch"
            :id="actor.id"
            :params="{ financeId: obj.finance.id, id: actor.id }"
            class-to-add="d-none"
            @form-build="setBuildActor"
            @is-sending="isSendingShare"
            @form-return="removeActor"
          ></FormCreator>
          <div class="row mb-3">
            <div class="col-md-6">
              <BlockContent inner-bloc-class="border-contract-blue">
                <div
                  v-if="
                    !user.isReadOnly &&
                    (ind === 'SURRENDER' || ind === 'CO_CLIENT' || ind === 'SUB_CLIENT' || ind === 'OLD_CLIENT')
                  "
                  class="my-2 row justify-content-end"
                >
                  <label class="fs-16 form-label-font" style="cursor: pointer" @click="deleteActor(actor.id)">
                    <div v-if="loading" class="text-center">
                      <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                    <div v-else e2e-button="actorDelete">{{ $t('button.delete') }} <i class="fas fa-times"></i></div>
                  </label>
                </div>
                <div class="row">
                  <div class="col-xl-4 col-md-12">
                    <label class="fs-16 form-label-font">{{ $t('contract.information.entity') }}</label>
                  </div>
                  <div class="col-xl-8 col-md-12">
                    <EntityLink v-if="actor?.entity" :entity="actor.entity" e2e-data="actorEntityName" />
                  </div>
                </div>
                <div class="my-2 row">
                  <label class="fs-16 form-label-font col-xl-4 col-md-12">{{ entitySirenLabel(actor) }}</label>
                  <div class="col-xl-8 col-md-12" e2e-data="actorEntitySiren">{{ actor?.entity?.siren }}</div>
                </div>
                <div class="my-2 row">
                  <label class="fs-16 form-label-font col-xl-4 col-md-12">{{ $t('contract.information.rcs') }}</label>
                  <div class="col-xl-8 col-md-12" e2e-data="actorEntityRcs">{{ actor?.entity?.rcs }}</div>
                </div>
                <div class="row">
                  <label class="fs-16 form-label-font col-xl-4 col-md-12">{{
                    $t('contract.information.address')
                  }}</label>
                  <div
                    class="col-xl-8 col-md-12"
                    v-html="actor?.entity?.address?.formattedHtml"
                    e2e-data="actorEntityAddress"
                  />
                </div>
              </BlockContent>
            </div>
            <div class="col-md-6">
              <BlockContent inner-bloc-class="border-contract-blue">
                <div v-if="!user.isReadOnly" class="my-2 row justify-content-end">
                  <label
                    :class="
                      'fs-16 form-label-font' + (disabled ? ' cursor-disabled filter-disabled-2' : ' cursor-pointer')
                    "
                    @[!disabled&&`click`]="showFormActor(actor.id)"
                  >
                    <div v-if="loading" class="text-center">
                      <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                    <div v-else e2e-button="updateActor">{{ $t('button.update') }} <i class="fas fa-edit" /></div>
                  </label>
                  <ActorFormModal
                    :ref="'actor' + actor.id"
                    :id="id"
                    :context="context"
                    :actor-id="actor.id"
                    :finance-id="obj.finance.id"
                    :type="ind"
                    @actor-sent="updateActor"
                    @is-loading="isLoading"
                  />
                </div>
                <template v-for="{ label, property, collectionProperty, onlyFor } in getUsersByType(ind, actor)">
                  <div v-if="!onlyFor || onlyFor === ind" class="my-2 row" :e2e-row="'actor-' + ind + '-' + property">
                    <label class="fs-16 form-label-font col-xl-4 col-md-12">
                      {{ $t(label) }}
                    </label>
                    <div class="col-xl-8 col-md-12" e2e-data="actorName">
                      <div v-if="collectionProperty">
                        <div
                          v-for="(user, index) in getObjectValueByPropertyPath(actor, collectionProperty) || []"
                          :key="index"
                          e2e-data="actorNameUser"
                        >
                          {{ getObjectValueByPropertyPath(user, property)?.name }}
                        </div>
                      </div>
                      <div v-else>
                        {{
                          getObjectValueByPropertyPath(actor, property)?.name ??
                          getObjectValueByPropertyPath(actor, property)?.[0]?.name
                        }}
                      </div>
                      <template
                        v-if="
                          hasRole('ROLE_REPORTING_VARIABLE') &&
                          getObjectValueByPropertyPath(actor, property)?.reportingVariables?.length > 0
                        "
                      >
                        <div>
                          <Badge
                            v-for="variable in getObjectValueByPropertyPath(actor, property).reportingVariables"
                            :key="variable.id"
                            type="primary"
                            class="mr-1"
                          >
                            {{ variable.name }}
                          </Badge>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
                <div class="my-2 row" v-if="actor?.billingAddress?.formattedHtml?.length">
                  <label class="fs-16 form-label-font col-xl-4 col-md-12">{{
                    $t('actor.fields.billingAddress.label')
                  }}</label>
                  <div
                    class="col-xl-8 col-md-12"
                    v-html="actor?.billingAddress?.formattedHtml"
                    e2e-data="actorBillingAddress"
                  />
                </div>
                <div class="my-2 row" v-if="actor.type === 'CO_CLIENT'">
                  <label class="fs-16 form-label-font col-xl-4 col-md-12">
                    {{ $t('actor.fields.shareRent.label') }}
                  </label>
                  <div class="col-xl-8 col-md-12" e2e-data="actorShareRent">{{ actor.shareRent }}</div>
                </div>
              </BlockContent>
            </div>
          </div>
        </div>
        <div
          v-if="!user.isReadOnly && (ind === 'SURRENDER' || ind === 'CO_CLIENT' || ind === 'SUB_CLIENT')"
          class="row d-flex justify-content-center"
        >
          <button
            type="button"
            :ref="ind"
            class="btn btn-primary"
            @click="showNewActor(ind)"
            :e2e-button="'actorAdd' + ind"
          >
            <i class="fas fa-plus-circle" /> {{ $t('actor.button.create.' + ind) }}
          </button>
        </div>
      </BlockContent>
    </div>

    <BlockContent v-else>
      <div class="row">
        <div class="col-md-6">
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
        </div>
        <div class="col-md-6">
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
        </div>
      </div>
    </BlockContent>

    <div v-if="!user.isReadOnly" class="row d-flex justify-content-center">
      <button
        type="button"
        class="btn btn-primary"
        :disabled="disabled"
        @click="showNewActor(null)"
        e2e-button="actorAdd"
      >
        <i class="fas fa-plus-circle" />
        {{ $t('actor.button.add') }}
      </button>
    </div>
  </div>
</template>
